'use strict';

/**
 * display-bulk-clear — pure payload builder for the Displays bulk
 * "clear assignment" action (displays.js beforeClearingModal's confirm
 * handler, ~line 466-481).
 *
 * Extracted so the Display.updateAll payload can be tested directly without
 * instantiating the Angular controller (this repo's convention for
 * controllers wired up via `.component(...)` — see limit-controls.js /
 * group-bulk-assign.js).
 */

var CLEAR_FIELD_BY_TYPE = {
    app: 'appId',
    group: 'groupId',
    playlist: 'playlistId',
    schedule: 'scheduleId',
};

/**
 * Builds the `data` payload for clearing a single assignment type. Only the
 * named field is nulled — clearing "app" does not imply clearing
 * group/playlist/schedule, matching the existing (intentional) asymmetry
 * with the bulk-assign path, which does clear the other three.
 */
function buildClearPayload(type) {
    var field = CLEAR_FIELD_BY_TYPE[type];
    if (!field) {
        return null;
    }

    var payload = {};
    payload[field] = null;
    return payload;
}

var displayBulkClear = {
    buildClearPayload: buildClearPayload,
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = displayBulkClear;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('displayBulkClear', displayBulkClear);
}
